import styled from 'styled-components';
import { BigButton } from '../../../../components/BigButton';
import { usePaymentModalStore } from '../../../../store/payment/paymentModalStore';
import { useState } from 'react';
import RadioInput from '../../../../components/Inputs/RadioInput';

const ContainerColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    justify-content: stretch;
    width: 100%;

    h2 {
        color: var(--Neutral-900, #18181b);
        font-size: 1.25rem;
        font-weight: 600;
        line-height: 1.8rem;
    }

    .installments {
        display: flex;
        flex-direction: column;
        border-radius: 0.75rem;
        gap: 0.5rem;
        overflow: hidden;

        & > .installment-option {
            display: flex;
            gap: 0.75rem;
            padding: 0.75rem;
            align-items: center;
            label {
                flex-grow: 1;
                color: var(--Neutral-900, #18181b);
                font-size: 1rem;
                font-weight: 400;
                line-height: 1.2rem;
            }

            input {
                height: 1rem;
                aspect-ratio: 1/1;
            }
        }

        & > .installment-option:nth-child(odd) {
            background: var(--Neutral-100, #f4f4f5);
        }
    }

    .buttons-wrapper {
        display: flex;
        gap: 0.75rem;

        > button {
            flex: 1 1 0;
        }
    }

    p.notice {
        padding: 0;
        font-weight: 400;
        font-size: 1.25rem;
    }
`;

interface Props {
    handleCloseModal: () => void;
}

export default function InstallmentsForm({ handleCloseModal }: Props) {
    const paymentModal = usePaymentModalStore();
    const [istallments, setInstallments] = useState<number>(
        paymentModal.installments || 1
    );

    const handleSubmit = () => {
        paymentModal.update({
            isVisible: false,
            installments: istallments,
            isntallmentsVisibility: false,
        });
    };

    // Regra de negócio: 1 parcela liberada a cada 200 reais
    const allowedInstallmentsCount = Math.floor(
        (paymentModal.purchaseTotal || 0) / 200
    );

    return (
        <ContainerColumn>
            <h2>Parcelamentos</h2>
            <div className="installments">
                {new Array(7).fill(0).map((_, index) => {
                    let baseText =
                        index === 1 ? 'À vista' : `${index}x sem juros`;
                    
                    return index === 0 ? (
                        <></>
                    ) : (
                        <RadioInput
                            text={baseText}
                            radioId={`installment-${index}`}
                            value={index}
                            currentSelected={istallments}
                            setCurrentSelected={setInstallments}
                            isDisabled={index > allowedInstallmentsCount && index !== 1}
                        />
                    );
                })}
            </div>
            <div className="buttons-wrapper">
                <BigButton
                    bgColor="tertiary"
                    color="secondary-alt"
                    children="Cancelar"
                    onClick={handleCloseModal}
                />
                <BigButton
                    bgColor="primary"
                    color="primary"
                    children="Salvar"
                    onClick={handleSubmit}
                />
            </div>
        </ContainerColumn>
    );
}
